import { HttpContextToken } from "@angular/common/http";
import { LoaderSpinnerTypes } from "@carm/_core/models/loader-types.model";

export const dateFormat = 'YYYY-MM-DD';
export const emptyNumber = '0.00'; // S4 null number
export const templateLimit = 100;
export const defaultCarmCurrency = 'CAD';
export const dateTimeFormat= "YYYY-MM-DDThh:mm:ss";
export const minStartDate = new Date(1970, 0, 1);

export const loaderSpinnerContext = new HttpContextToken<string>(() => LoaderSpinnerTypes.FullPage);
